import React from "react";
import classNames from "classnames";
import { USER_1_KOKORIN, USER_2_KOROVCHENO } from "../../Pages/Home";
import { buildApiUrl } from "../../config/api";

const Persons = ({ currentUser, serCurrentUser }) => {
  const trainers = [
    {
      id: USER_1_KOKORIN.id,
      name: "Кокорін Ілля",
      role: "Силові та функціональні тренування",
      image: "../img/IMG_3668.JPG",
    },
    {
      id: USER_2_KOROVCHENO.id,
      name: "Коровчено Каріна",
      role: "Персональний супровід та техніка",
      image: "../img/IMG_5596.JPG",
    },
  ];

  const [textComment, setTextComment] = React.useState(null);

  React.useEffect(() => {
    const getText = async () => {
      const res = await fetch(buildApiUrl("/api/text"), {
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        mode: "cors",
      });
      const data = await res.json();
      setTextComment(data.text);
    };
    getText();
  }, []);

  return (
    <section className="trainers-section">
      <div className="section-heading">
        <div>
          <div className="section-kicker">Команда</div>
          <h2>Оберіть тренера</h2>
        </div>
        <div className="section-note">2 фахівці • швидке бронювання онлайн</div>
      </div>

      <div className="persons-contaner">
        {trainers.map((trainer) => (
          <div
            key={trainer.id}
            className={classNames("item", {
              selected: currentUser === trainer.id,
            })}
            onClick={() => serCurrentUser(trainer.id)}
          >
            <div className="trainer-card-copy">
              <div className="trainer-status">
                {currentUser === trainer.id ? "Обрано" : "Доступний до запису"}
              </div>
              <div className="trainer-name">{trainer.name}</div>
              <div className="trainer-role">{trainer.role}</div>
            </div>
            <img src={trainer.image} alt={trainer.name} />
          </div>
        ))}
      </div>
      {textComment ? <div className="description-text">{textComment}</div> : null}
    </section>
  );
};

export default Persons;
